import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Observable, Subject } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';
import { TablePaginate } from '../../../shared/classes/table-paginate';
import { Sort } from '@angular/material';
import {LotClient} from "../classes/lot-client";
import {Lot} from "../classes/lot";
import { TypeRefusPassation } from '../classes/type_refus_passation';
import {DateMontant} from "../../batiment/batiment-restant-du/batiment-restant-du.component";


@Injectable()
export class InfrastructureService {

    private lotsPlanFacturation = new Subject<string>();

    constructor (
        private apiService: ApiService
        ) {}

    getLots(type_transaction?: string, archive?: string, paginate?: TablePaginate, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.get('infrastructure/lot'
        + (type_transaction ? '/type_transaction/' + type_transaction : '')
        + (archive ? '/archive/' + archive : '')
        + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
        + (sort ? '/sort/' + sort.active + '/' + sort.direction : ''));
    }

    getLotsFiltered(type_transaction?: string, archive?: string, paginate?: TablePaginate, sort?: Sort, filters?: any): Observable<ApiResponse> {
        return this.apiService.post(
            'infrastructure/lot-search'
            + (type_transaction ? '/type_transaction/' + type_transaction : '')
            + (archive ? '/archive/' + archive : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : ''),
            filters
        );
    }

    getPrevNextBien(index: string, type_transaction?: string, archive?: string, paginate?: TablePaginate, sort?: Sort, filters?: any): Observable<ApiResponse> {
        return this.apiService.post('infrastructure/lot-previous-next'
            + (type_transaction ? '/type_transaction/' + type_transaction : '')
            + (archive ? '/archive/' + archive : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
            + (index ? '/index/' + index : ''),
            filters
        );
    }

    getTypesBiens(): Observable<ApiResponse> {
        return this.apiService.get('type_bien');
    }

    getTypesDalles(): Observable<ApiResponse> {
        return this.apiService.get('type_dalle');
    }

    getTypesToitures(): Observable<ApiResponse> {
        return this.apiService.get('type_toiture');
    }

    getTypesFacades(): Observable<ApiResponse> {
        return this.apiService.get('type_facade');
    }

    getOriginesMandats(): Observable<ApiResponse> {
        return this.apiService.get('lot_mandat_origine');
    }

    getTypesConventions(): Observable<ApiResponse> {
        return this.apiService.get('type_convention');
    }

    getTypesTransactions(): Observable<ApiResponse> {
        return this.apiService.get('type_transaction');
    }

    getTypesPassations(): Observable<ApiResponse> {
        return this.apiService.get('type_passation');
    }

    fetchMontantCommissions(): Observable<ApiResponse> {
        return this.apiService.get('infrastructure/commissions/');
    }

    deleteLot(id: any): Observable<ApiResponse> {
        return this.apiService.delete('lot/' + id);
    }

    deleteBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.delete('batiment/' + id);
    }

    getBatiments(archive?: string): Observable<ApiResponse> {
        return this.apiService.get('infrastructure/batiment' + (archive ? '/archive/' + archive : ''));
    }

    getBatimentsListFiltered(archive?: string, options?: string, filters?: any) {
        return this.apiService.post('infrastructure/batiment-list-search/' + (archive ? 'archive/' + archive : '') + (options ? 'option/' + options : ''), filters);
    }

    getBatimentsFiltered(archive?: string, paginate?: TablePaginate, sort?: Sort, filters?: any): Observable<ApiResponse> {
        return this.apiService.post(
            'infrastructure/batiment-search'
            + (archive ? '/archive/' + archive : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : ''),
            filters
        );
    }

    getBatimentsByMaitre(maitreId?: string): Observable<ApiResponse> {
        return this.apiService.post(
            'infrastructure/batiments-maitre'
            + (maitreId ? '/maitreId/' + maitreId : '')
        );
    }

    getProjetsListFiltered(archive?: string, options?: string, filters?: any) {  
        return this.apiService.post('infrastructure/projet-list-search/' + (archive ? 'archive/' + archive : '') + (options ? 'option/' + options : ''), filters);
    }

    getLotsByMaitre(maitreId?: string): Observable<ApiResponse> {
        return this.apiService.post(
            'infrastructure/lots-maitre'
            + (maitreId ? '/maitreId/' + maitreId : '')
        );
    }

    getLotsBatimentFiltered(id: string, archive?: string, paginate?: TablePaginate, sort?: Sort, filters?: any): Observable<ApiResponse> {
        return this.apiService.get('batiment/display/lot/' + id
            + (archive ? '/archive/' + archive : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : ''),
            filters
        );
    }

    getAnnonce(id: string): Observable<ApiResponse> {
        return this.apiService.get('annonce/' + id);
    }

    getLot(id: string): Observable<ApiResponse> {
        return this.apiService.get('lot/' + id);
    }

    getLotsListe(data: any): Observable<ApiResponse> {
        return this.apiService.post('lots-liste', data);
    }

    getBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment/' + id);
    }

    insertLot(data: any): Observable<ApiResponse> {
        return this.apiService.post('lot', data, {}, {createDriveFolder: true});
    }

    insertBatiment(data: any): Observable<ApiResponse> {
        return this.apiService.post('batiment', data, {}, {createDriveFolder: true});
    }

    updateLot(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('lot/' + id, data);
    }

    dupliquerLot(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('copie-lot/' + id, data);
    }

    dupliquerBatiment(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('copie-batiment/' + id, data);
    }

    appliquerInfoBatimentLots(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('info-batiment-lots/' + id, data);
    }

    updateBatiment(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('batiment/' + id, data);
    }

    getDetailsLot(id: string): Observable<ApiResponse> {
        return this.apiService.get('lot/' + id);
    }

    getDetailsBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment/' + id);
    }

    getHistoriqueLot(id: string): Observable<ApiResponse> {
        return this.apiService.get('historique/lot/' + id);
    }

    getHistoriqueBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('historique/batiment/' + id);
    }

    getLotsBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment/lot/' + id);
    }

    getLotsIdsBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment/lot/id/' + id);
    }

    exportCsv(type: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('export-' + type, data);
    }

    getLotsByTerm(term: string, option?: string): Observable<ApiResponse> {
        // term = btoa(term); // encodage en base64 pour éviter les erreurs dûes à des caractères spéciaux dans l'url comme le '/'
        return this.apiService.get('infrastructure/lot/search/' + term + (option ? '/' + option : ''));
    }

    getBatimentsByTerm(term: string, option?: string): Observable<ApiResponse> {
        // term = btoa(term); // encodage en base64 pour éviter les erreurs dûes à des caractères spéciaux dans l'url comme le '/'
        return this.apiService.get('infrastructure/batiment/search/' + term + (option ? '/' + option : ''));
    }

    getMandants(): Observable<ApiResponse> {
        return this.apiService.get('infrastructure/mandant/');
    }

    insertTypeDalle(data: any): Observable<ApiResponse> {
        return this.apiService.post('type_dalle', data);
    }

    insertTypeConvention(data: any): Observable<ApiResponse> {
        return this.apiService.post('type_convention', data);
    }

    updateTypeConvention(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('type_convention/' + id, data);
    }

    deleteTypeConvention(id: string): Observable<ApiResponse> {
        return this.apiService.delete('type_convention/' + id);
    }

    getConventions(source: string, lotId: string): Observable<ApiResponse> {
        return this.apiService.get('convention/' + source + '/source_id/' + lotId);
    }

    getConvention(source: string, conId: string): Observable<ApiResponse> {
        return this.apiService.get('convention/' + source + '/' + conId);
    }

    insertConvention(source: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('convention/' + source, data);
    }

    updateConvention(source: string, id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('convention/' + source + '/' + id, data);
    }

    deleteConvention(source: string, id: string): Observable<ApiResponse> {
        return this.apiService.delete('convention/' + source + '/' + id);
    }

    getVenteType(): Observable<ApiResponse> {
        return this.apiService.get('get_type_transaction/vente');
    }

    getLotClient(lotId): Observable<ApiResponse> {
        return this.apiService.get(`lot_client/${lotId}`);
    }

    updateLotClient(lotId, lotClient: LotClient) {
        return this.apiService.put(`lot_client/${lotId}`, JSON.stringify(lotClient));
    }

    createLotClient(lotClient: LotClient) {
        return this.apiService.post(`lot_client`, JSON.stringify(lotClient));
    }

    deleteLotClient(lotId) {
        return this.apiService.delete(`lot_client/${lotId}`);
    }

    getAssociatedLot(id: string): Observable<ApiResponse> {
        return this.apiService.get(`identitie-lot-associe/${id}`);
    }

    updateLots(data: Lot[]): Observable<ApiResponse> {
        return this.apiService.patchList(`infrastructure/lot`, JSON.stringify(data));
    }

    facturationActe(data: Lot): Observable<ApiResponse> {
        return this.apiService.post(`infrastructure/lot/acte`, JSON.stringify(data));
    }
    
    getFactureActeSoldeByBatiment(batimentId: string){
        return this.apiService.get(`infrastructure/batiment-facture-acte/${batimentId}`);
    }

    getModuleCalculeHistorique(lot: Lot): Observable<ApiResponse> {
        return this.apiService.get(`lot/module-calcul-historique/${lot.id}`);
    }

    fetchIndice(pays: string): Observable<ApiResponse> {
        return this.apiService.get(`lot/indice/${pays}`);
    }

    facturerQPAdue(lot: Lot, data: DateMontant): Observable<ApiResponse> {
        return this.apiService.post(`lot/facture/qpa_due/${lot.id}`, data);
    }

    facturerQPCRealisee(lot: Lot): Observable<ApiResponse> {
        return this.apiService.get(`lot/facture/qpc_realisee/${lot.id}`);
    }

    getAllLots(): Observable<ApiResponse> {
        return this.apiService.get('infrastructure/lots');
    }

    getBudgetLot(data: any): Observable<ApiResponse> {
        return this.apiService.get('budget-lot/' + data, data);
    }

    getSingleLotsByBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment/singleLots/' + id);
    }

    getSingleLotsByCustomer(id: string, clientId: string, loadAvenants: boolean, selectedLot: string): Observable<ApiResponse> {
        const params = {}

        if (clientId) {
            params['client'] = clientId;
        }

        if (selectedLot) {
            params['selectedLot'] = selectedLot;
        }

        params['loadAvenants'] = loadAvenants;

        return this.apiService.get('batiment/singleLots/plan-facturation/' + id, null, params);
    }

    getSingleLotsNumeros(id: string, clientId: string): Observable<ApiResponse> {
        const params = {};
        
        if (clientId) {
            params['client'] = clientId;
        }

        return this.apiService.get('batiment/singleLots/numeros/' + id, null, params);
    }
    
    getTypesConditionsSuspensives(): Observable<ApiResponse> {
        return this.apiService.get('type_condition_suspensive');
    }

    getTypesFrais(): Observable<ApiResponse> {
        return this.apiService.get('type_frais');
    }

    getTypesRefusPassation(actif: boolean): Observable<ApiResponse> {
        return this.apiService.get('type_refus_passation'
        + (actif ? '/actif/' + actif : '')
        );
    }

    saveTypeRefusPassation(type: TypeRefusPassation): Observable<ApiResponse> {
        return this.apiService.post('type_refus_passation', type);
    }

    getBatimentMaitresOuvrage(batId) : Observable<ApiResponse> {
        return this.apiService.get('batiment-mo/' + batId);
    }

    getBaloiseLogin(): Observable<ApiResponse> {
        return this.apiService.get('simulation-assurance/login');
    }

    getBaloiseCalculation(data: any): Observable<ApiResponse> {
        return this.apiService.post('simulation-assurance/calculation', data);
    }

    getBaloiseAutomation(data: any): Observable<ApiResponse> {
        return this.apiService.post('simulation-assurance/automation', data);
    }

    downloadExportStatistiqueBatiment(batId: string): Observable<Blob> {
        return this.apiService.get(`export-statistiques-batiment/${batId}`, {responseType: 'blob'});
    }

    downloadExportCompteurBatiment(batId: string): Observable<Blob> {
        return this.apiService.get(`export-compteurs-batiment/${batId}`, {responseType: 'blob'});
    }

    libererLot(lotId): Observable<ApiResponse> {
        return this.apiService.put('infrastructure/lot/liberer/' + lotId, {tpt_id: null});
    }

    getLotsRecapitulatifBatiment(batimentId: string): Observable<ApiResponse> {
        return this.apiService.get(`recapitulatif-lots/batiment/${batimentId}`);
    }

    getLotsRecapitulatifBatimentCsv(batimentId: string): Observable<ApiResponse> {
        return this.apiService.get(`recapitulatif-lots-csv/batiment/${batimentId}`);
    }

    getListingReceptionLotsBatiment(batimentId: string): Observable<ApiResponse> {
        return this.apiService.get(`listing-reception-lots/batiment/${batimentId}`);
    }

    getListingReceptionLotsBatimentCsv(batimentId: string): Observable<ApiResponse> {
        return this.apiService.get(`listing-reception-lots-csv/batiment/${batimentId}`);
    }

    getBilanPersonnaliseCsv(batimentId: string): Observable<ApiResponse> {
        return this.apiService.get(`bilan-personnalise-csv/batiment/${batimentId}`);
    }

    getBilanPersonnaliseProjetCsv(projetId: string): Observable<ApiResponse> {
        return this.apiService.get(`bilan-personnalise-csv/projet/${projetId}`);
    }

    fetchAllRoles(bureauId, batimentId = null, banqueId?): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;
        if (batimentId)
            params['batimentId'] = batimentId;
        if (banqueId !== undefined)
            params['banqueId'] = batimentId;

        return this.apiService.get('infrastructure/lot/client/roles', null, params);
    }

    getPeriodeRemiseClesBatiment(batimentId: string, annee: string = null, mois: string = null): Observable<ApiResponse> {
        if (annee && mois) {
            return this.apiService.get(`remise-cles-lots/batiment/${batimentId}/${annee}/${mois}`);
        } else {
            return this.apiService.get(`remise-cles-lots/batiment/${batimentId}`);
        }
    }

    downloadPeriodeRemiseClesBatiment(batimentId: string, annee: string = null, mois: string = null): Observable<Blob> {
        if (annee && mois) {
            return this.apiService.get(`remise-cles-lots-pdf/batiment/${batimentId}/${annee}/${mois}`, {responseType: 'blob'});
        } else {
            return this.apiService.get(`remise-cles-lots-pdf/batiment/${batimentId}`, {responseType: 'blob'});
        }
    }

    downloadListingReceptionLots(batimentId: string): Observable<Blob> {
        return this.apiService.get(`listing-reception-lots-pdf/batiment/${batimentId}`, {responseType: 'blob'});
    }

    downloadRecapChoixClients(batimentId: string): Observable<Blob> {
        return this.apiService.get(`recapitulatif-choix-clients-pdf/batiment/${batimentId}`, {responseType: 'blob'});
    }

    downloadBilanPersonnalise(batimentId: string): Observable<Blob> {
        return this.apiService.get(`bilan-personnalise-pdf/batiment/${batimentId}`, {responseType: 'blob'});
    }

    downloadBilanPersonnaliseProjet(projetId: string): Observable<Blob> {
        return this.apiService.get(`bilan-personnalise-pdf/projet/${projetId}`, {responseType: 'blob'});
    }

    indexationTrachesLotsBatiment(batimentId: string, nouvelIndiceId: string) {
        return this.apiService.post(`indexation-tranches-lots/${batimentId}`, JSON.stringify({ind_id: nouvelIndiceId}));
    }

    getLotsVisibility(id: string): Observable<ApiResponse> {
        return this.apiService.get('lots-plan-facturation', id);
    }

    updateLotsPlanFacturation(data: any): Observable<ApiResponse> {
        return this.apiService.post('update-lots-plan-facturation', data);
    }

    setLotsPlanFacturation(lotsPlanFacturation) {
        this.lotsPlanFacturation = lotsPlanFacturation;
    }

    getLotsPlanFacturation() {
        return this.lotsPlanFacturation;
    }

    getAllValidatedOrders() {
        return this.apiService.get('lots-validation');
    }

    updateSoumissionLotIndexation(lotId, nonSoumisIndexation) {
        return this.apiService.post(`soumission-lot-indexation/${lotId}`, JSON.stringify({non_soumis_indexation: nonSoumisIndexation}));
    }

    getListeProjetsByBureau(bureauId: string): Observable<ApiResponse> {
        return this.apiService.get(`projet-liste/bureau/${bureauId}`);
    }

}
